import React from "react"
import BoxPage from "../../../../../../components/v2/layout/boxPage/boxPage"
import SchoolCalendarPicker from "../../../../../../components/v2/inputs/pickers/schoolCalendarPicker"
import { useIdParam } from "../../../../../../hooks/useIdParam"
import SegmentPicker from "../../../../../../components/v2/inputs/pickers/segmentPicker"
import SectionPicker from "../../../../../../components/v2/inputs/pickers/sectionPicker"
import { calendarGrades } from "../../../../../../library/constants/educationalDictionary"
import GradePicker from "../../../../../../components/v2/inputs/pickers/gradePicker"
import { useQuery } from "@tanstack/react-query"
import { SEGMENTS } from "../../../../../../library/store/actions/types/groupsTypes"
import { weekDays } from "../../../../../../library/utils/timeConvert"
import { getObjectById } from "../../../../../../library/utils/arrays"
import { rotationTypes } from "../../../../../../library/constants/groupTypes"
import { groupBy } from "lodash"
import {
  Cell,
  MobileContainer,
  Row,
  ScrollContainer,
  StyledTable,
  TBody,
  THead,
  THeadCellContent,
  THeadRow,
} from "../../../../../../components/v2/table/table"
import { useToggle } from "../../../../../../hooks/useToggle"
import TeacherScheduleAssignmentFormModal from "./components/TeacherScheduleAssignmentFormModal"

const mockedBlocksData = [
  {
    id: 20,
    name: "Block 1",
    section_id: 21,
    segment_id: 17,
    is_all_day: false,
    rotations: [0, 0, 0, 4, 5, 0, 0],
    deleted: false,
    time_from: "08:00",
    time_to: "09:00",
    ts: 480,
  },
  {
    id: 21,
    name: "Block 2",
    section_id: 21,
    segment_id: 17,
    is_all_day: false,
    rotations: [0, 3, 5],
    deleted: false,
    time_from: "09:15",
    time_to: "10:15",
    ts: 480,
  },
  {
    id: 13,
    name: "Block 3",
    section_id: 21,
    segment_id: 17,
    is_all_day: false,
    rotations: [0, 0, 3, 0, 5, 0, 0],
    deleted: false,
    time_from: "10:30",
    time_to: "11:30",
    ts: 540,
  },
  {
    id: 15,
    name: "Block 4",
    section_id: 21,
    segment_id: 17,
    is_all_day: false,
    rotations: [0, 2, 3, 4, 5, 6, 0],
    deleted: false,
    time_from: "11:45",
    time_to: "12:45",
    ts: 720,
  },
  {
    id: 16,
    name: "Block 5",
    section_id: 21,
    segment_id: 17,
    is_all_day: false,
    rotations: [1, 2, 3, 4, 5, 0, 0],
    deleted: false,
    time_from: "14:00",
    time_to: "15:00",
    ts: 780,
  },
]

const mockedScheduleData = [
  {
    id: 20,
    name: "Block 1",
    time_from: "08:00",
    time_to: "09:00",
    tracks: [
      {
        id: 1,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      { id: 2, subject: null, teacher: null },
      { id: 3, subject: null, teacher: null },
      {
        id: 4,
        subject: { id: 2, name: "Subject2" },
        teacher: { id: 1, first_name: "Some3", last_name: "Person3" },
      },
    ],
  },
  {
    id: 21,
    name: "Block 2",
    time_from: "09:15",
    time_to: "10:15",
    tracks: [
      {
        id: 1,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      {
        id: 2,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      {
        id: 3,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      {
        id: 4,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
    ],
  },
  {
    id: 13,
    name: "Block 3",
    time_from: "10:30",
    time_to: "11:30",
    tracks: [
      {
        id: 1,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      {
        id: 2,
        subject: { id: 2, name: "Subject2" },
        teacher: { id: 2, first_name: "Some2", last_name: "Person2" },
      },
      {
        id: 3,
        subject: { id: 3, name: "Subject3" },
        teacher: { id: 3, first_name: "Some3", last_name: "Person3" },
      },
      {
        id: 4,
        subject: { id: 4, name: "Subject4" },
        teacher: { id: 4, first_name: "Some4", last_name: "Person4" },
      },
    ],
  },
  {
    id: 15,
    name: "Block 4",
    time_from: "11:45",
    time_to: "12:45",
    tracks: [
      {
        id: 1,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      { id: 2, subject: null, teacher: null },
      {
        id: 3,
        subject: { id: 2, name: "Subject7" },
        teacher: { id: 2, first_name: "Some5", last_name: "Person5" },
      },
      {
        id: 4,
        subject: { id: 3, name: "Subject2" },
        teacher: { id: 3, first_name: "Some2", last_name: "Person2" },
      },
    ],
  },
  {
    id: 16,
    name: "Block 5",
    time_from: "14:00",
    time_to: "15:00",
    tracks: [
      {
        id: 1,
        subject: { id: 1, name: "Subject1" },
        teacher: { id: 1, first_name: "Some", last_name: "Person" },
      },
      {
        id: 2,
        subject: { id: 2, name: "Subject2" },
        teacher: { id: 2, first_name: "Some2", last_name: "Person2" },
      },
      {
        id: 3,
        subject: { id: 3, name: "Subject3" },
        teacher: { id: 3, first_name: "Some3", last_name: "Person3" },
      },
      {
        id: 4,
        subject: { id: 4, name: "Subject4" },
        teacher: { id: 4, first_name: "Some4", last_name: "Person4" },
      },
    ],
  },
]

const SchoolScheduleTeachers = () => {
  const groupId = useIdParam("groupId")

  const [filters, setFilters] = React.useState({
    schedule: null,
    grade: null,
    segment: null,
    section: null,
  })
  const [filterErrors, setFilterErrors] = React.useState({
    schedule: false,
    grade: false,
    segment: false,
    section: false,
  })

  const onFilterChange = (name) => (event) => {
    console.log("event", event.target.value)
    setFilters({
      ...filters,
      [name]: event.target.value,
    })
    setFilterErrors({
      ...filterErrors,
      [name]: !event.target.value,
    })
  }

  const [blocks, setBlocks] = React.useState([])

  const { data, refetch, isSuccess } = useQuery({
    queryKey: [
      SEGMENTS.SECTIONS.BLOCKS.LIST,
      { section_id: filters.section?.id, offset: 0, limit: 100 },
    ],
    enabled: !!filters.section?.id,
  })

  React.useEffect(() => {
    if (filters.section?.id) {
      refetch()
    }
  }, [filters.section])

  const sectionRotations = React.useMemo(() => {
    return groupBy(
      filters.section?.rotations?.map((r, i) => ({
        weekDay: weekDays[i],
        type: getObjectById(rotationTypes, r).name,
      })),
      (v) => v.type
    )
  }, [filters.section])

  // console.log(
  //   groupBy(
  //     filters.section?.rotations?.map((r, i) => ({
  //       weekDay: weekDays[i],
  //       type: getObjectById(rotationTypes, r).name,
  //     })),
  //     (v) => v.type
  //   )
  // )

  console.log(sectionRotations)

  const columns = [
    { id: "tracks", label: "" },
    ...mockedScheduleData.map((b) => ({
      id: b.id,
      label: b.name,
      time: `${b.time_from} - ${b.time_to}`,
    })),
  ]
  const isColumnFluid = columns.length < 4
  const sectionTracksNumber = 4
  const rows = Array.from({ length: sectionTracksNumber }).map((_, i) => {
    return [
      `Track ${i + 1}`,
      ...mockedScheduleData.map((r) => ({ id: r.id, track: r.tracks[i] })),
    ]
  })

  console.log(rows)

  const getCellContent = (cell, idx) => {
    if (idx === 0 && cell) {
      return <span>{cell}</span>
    }

    if (cell?.track?.teacher && cell?.track?.subject) {
      return (
        <>
          <p className={"text-black87"}>
            {cell.track.teacher.first_name} {cell.track.teacher.last_name}
          </p>
          <p className={"text-black54 text-xs"}>{cell.track.subject.name}</p>
        </>
      )
    }

    return <span>—</span>
  }

  const [isAssignationModalOpen, toggleAssignationModal] = useToggle(false)
  const [activeSlot, setActiveSlot] = React.useState({
    blockId: null,
    trackIdx: null,
    track: null,
  })

  const initAssignation = (blockId, trackIdx, track) => {
    setActiveSlot({ blockId, trackIdx, track })
    toggleAssignationModal()
  }

  const onAssignationModalClose = () => {
    toggleAssignationModal()
    setActiveSlot({ blockId: null, track: null, isFree: true })
  }

  return (
    <BoxPage title={"Teacher schedule"}>
      <div className={"mb20"}>
        <SchoolCalendarPicker
          groupId={groupId}
          value={filters.schedule}
          hasError={filterErrors.schedule}
          onChange={onFilterChange("schedule")}
        />
        <GradePicker
          grades={calendarGrades}
          value={filters.grade}
          onChange={onFilterChange("grade")}
        />
        <SegmentPicker
          onChange={onFilterChange("segment")}
          hasError={filterErrors.segment}
          value={filters.segment}
          scheduleId={filters.schedule?.id}
          grade={filters.grade?.id}
          isWaitingForOtherFieldsMessage={"First select schedule"}
        />
        <SectionPicker
          onChange={onFilterChange("section")}
          hasError={filterErrors.section}
          value={filters.section}
          segmentId={filters.segment?.id}
        />
      </div>
      <div>
        <div>
          {Object.entries(sectionRotations).map(([key, val]) => {
            const days = val.map((d) => d.weekDay.substring(0, 3)).join(", ")
            return (
              <p key={key}>
                <strong>{key}: </strong>
                <span>{days}</span>
                {/*{val.map((v) => {*/}

                {/*  return <span>{days}</span>;*/}
                {/*})}*/}
              </p>
            )
          })}
        </div>
        <MobileContainer>
          <ScrollContainer>
            <StyledTable>
              <THead
                fluid={isColumnFluid}
                columnsNumber={columns.length}
                // style={{ width: "auto" }}
              >
                <THeadRow>
                  {columns.map((column, i) => (
                    <Cell th fluid={isColumnFluid} key={column.label}>
                      <THeadCellContent as={"div"}>
                        <div>
                          <h4 className={"text-black87"}>{column.label}</h4>
                          <span className={"text-black54 text-xs"}>
                            {column.time}
                          </span>
                        </div>
                      </THeadCellContent>
                    </Cell>
                  ))}
                </THeadRow>
              </THead>
              <TBody fluid={isColumnFluid} columnsNumber={columns.length}>
                {rows.map((row, rowIdx) => (
                  <Row
                    key={rowIdx}
                    fluid={isColumnFluid}
                    columnsNumber={columns.length}
                    noHoverBg
                  >
                    {row.map((cell, cellIdx) => {
                      const cellContent = getCellContent(cell, cellIdx)

                      return (
                        <Cell key={cellIdx} fluid={isColumnFluid} autoHeight>
                          {cellIdx > 0 ? (
                            <button
                              className={"w-full h-full hover:bg-primary15"}
                              disabled={!filters.schedule}
                              onClick={() =>
                                initAssignation(
                                  cell.id,
                                  rowIdx + 1,
                                  rowIdx > 0 ? cell.track : null
                                )
                              }
                            >
                              {cellContent}
                            </button>
                          ) : (
                            <p>{cellContent}</p>
                          )}
                        </Cell>
                      )
                    })}
                  </Row>
                ))}
              </TBody>
            </StyledTable>
          </ScrollContainer>
        </MobileContainer>
      </div>
      {isAssignationModalOpen && (
        <TeacherScheduleAssignmentFormModal
          open={isAssignationModalOpen}
          onClose={onAssignationModalClose}
          activeSlot={activeSlot}
          schoolSchedule={filters.schedule}
        />
      )}
    </BoxPage>
  )
}

export default SchoolScheduleTeachers
